<template>
  <div class="table-responsive">
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Cargo</th>
          <th>E-mail</th>
          <th class="text-center">Status do Usuário</th>
          <th
            v-if="isCollaboratorPrincipalProject && canEditProject"
            class="text-center"
          >
            Ações
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="collaborator in collaborators" :key="collaborator.id">
          <td>{{ collaborator.name }}</td>
          <td>{{ collaborator.role }}</td>
          <td>{{ collaborator.email }}</td>
          <td
            class="text-center"
            v-html="statusTranslate(collaborator.status)"
          />
          <td
            v-if="isCollaboratorPrincipalProject && canEditProject"
            class="text-center"
          >
            <button
              type="button"
              class="btn btn-outline-danger btn-icon rounded-pill"
              title="Remover Colaborador do Sumário Executivo"
              @click="$emit('deleteCollaborator', collaborator.id)"
            >
              <i class="ph-trash" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'ListCollaborators',

  props: {
    collaborators: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      statusTranslate,
    }
  },

  computed: {
    ...mapGetters(['isCollaboratorPrincipalProject', 'canEditProject']),
  },
}
</script>
